import React, { useRef, useEffect, useState } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
  colors,
  Button,
  ListItem,
  makeStyles,
} from '@material-ui/core'
import {
  useSelector,
  // useDispatch
} from 'react-redux'
import {
  // getUnseenNumber,
  selectorUnseenNotifications,
} from '../../../app/slices/notificationSlice'
// import ProfessionalCourseIconDark from '../../../icons/ProfessionalCourseIconDark'

const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === 'dark'
  return ({
    item: {
      display: 'flex',
      paddingBottom: 0,
      // paddingLeft: '10px',
      // transition: 'all 0.5s',
    },
    rootItem: {
      paddingTop: 0,
      marginTop: '8px',
      '&::before': {
        content: '',
      },
    },
    button: {
      border: '5px solid #00000000',
      borderRadius: '40px',
      // color: isDark ? theme.palette.text.secondary : theme.palette.text.primary,
      ...theme.button,
      fontWeight: theme.typography.fontWeightMedium,
      justifyContent: 'flex-start',
      letterSpacing: 0,
      textTransform: 'none',
      width: '100%',
      minHeight: 52,
    },
    dropButton: {
      border: '5px solid #00000000',
      borderRadius: '40px',
      ...theme.button,
      fontWeight: theme.typography.fontWeightMedium,
      justifyContent: 'flex-start',
      letterSpacing: 0,
      textTransform: 'none',
      width: '100%',
      minHeight: 52,
      '&:after': {
        content: '""',
        backgroundImage: `url(${window.location.origin}/images/Subtraction1.svg)`,
        backgroundColor: '#ffffff',
        borderRadius: '50%',
        backgroundRepeat: ' no-repeat',
        backgroundPosition: 'center',
        position: 'absolute',
        width: '27px',
        right: '10px',
        height: '27px',
        stroke: '#000',
      },
    },
    icon: {
      marginLeft: theme.spacing(0),
      color: '#fff',
    },
    icon2: {
      marginLeft: theme.spacing(0),
      color: '#3a455e',
    },
    title: {
      marginLeft: theme.spacing(1),
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#ffffff',
    },
    textButton: {
      padding: '0 8px',
    },
    active: {
      backgroundColor: isDark ? colors.yellow[300] : '#e6332a',
      border: '5px solid #f4f4f4',
      '& $icon': {
        color: isDark ? colors.yellow[300] : '#ffffff !important',
      },
      '&:after': {
        content: '""',
        backgroundImage: `url(${window.location.origin}/images/arrowLeft.svg)`,
        backgroundRepeat: ' no-repeat',
        width: '34px',
        height: '30px',
        right: '5.5px',
        top: '5.7px',
        backgroundColor: 'inherit',
      },
      '&:hover': {
        backgroundColor: '#d1130a',
      },
      '@media (max-width: 960px)': {
        '&:after': {
          content: '""',
          backgroundImage: `url(${window.location.origin}/images/arrowLeft.svg)`,
          backgroundRepeat: ' no-repeat',
          width: '34px',
          height: '30px',
          right: '5px',
          top: '5.2px',
          backgroundColor: 'inherit',
        },
      },
    },
    activeDropMain: {
      backgroundColor: isDark ? colors.yellow[300] : '#e6332a',
      border: '5px solid #f4f4f4',
      '& $icon': {
        color: isDark ? colors.yellow[300] : '#ffffff !important',
      },
      '&:after': {
        content: '""',
        backgroundImage: `url(${window.location.origin}/images/Subtraction1.svg)`,
        backgroundColor: '#ffffff',
        borderRadius: '50%',
        backgroundRepeat: ' no-repeat',
        backgroundPosition: 'center',
        width: '27px',
        right: '10px',
        height: '27px',
      },
      '&:hover': {
        backgroundColor: '#d1130a',
      },
    },
    activeDrop: {
      backgroundColor: isDark ? colors.yellow[300] : '#e6332a',
      border: '5px solid #f4f4f4',
      margin: '0 auto',
      '& $icon': {
        color: isDark ? colors.yellow[300] : '#ffffff !important',
      },
      '&:hover': {
        backgroundColor: '#d1130a',
      },
    },
    icons: {
      color: '#b2b6c0',
      transition: '0.2s',
      '&:hover': {
        color: '#f39994',
      },
    },
    AlertIconStatus: {
      // color: '#e9625b',
      width: '12px',
      height: '12px',
      backgroundColor: '#7bb872',
      display: 'inline-block',
      borderRadius: '50%',
      position: 'absolute',
      right: 80,

    },
  })
})

const NavItem = ({
  className,
  href,
  icon: Icon,
  iconTwo: IconTwo,
  title,
  child,
  dropDown,
  handleOpenDropDown,
  handleCloseDropDown,
  isChild,
  isParent,
  ...rest
}) => {
  const classes = useStyles()
  const activeItem = useRef(null)
  const unSeen = useSelector(selectorUnseenNotifications)
  // const dispatch = useDispatch()

  const [isChildren, setIsChildren] = useState(false)

  useEffect(() => {
    // dispatch(getUnseenNumber())
  }, [])

  const executeScroll = () => {
    activeItem.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    if (isChildren && !dropDown) {
      setIsChildren(false)
    }
  }

  // let color = ''

  // if (dropDown && isChild) {
  //   color = '#3a455e'
  // }

  // const aTag = document.querySelector('.dropButton')

  // let stroke = ''

  // if (!isChild) {
  //   stroke = '#fff !important'
  // } else {
  //   stroke = '#3a455e'
  // }

  // const handleClose = () => {
  //   setIsChildren(false)
  // }

  // const handleOpen = () => {
  //   setIsChildren(!dropDown)
  // }

  let icon = <Icon />

  if (isChildren && dropDown) {
    icon = <IconTwo />
  } else {
    icon = <Icon />
  }

  return (
    <ListItem
      className={clsx(classes.item, className)}
      classes={{ root: classes.rootItem }}
      style={{
        padding: '0 !important',
      }}
      disableGutters
      {...rest}
      onClick={executeScroll}
    >
      <Button
        style={{
          padding: '0 !important',
          color: (child
 && dropDown) || isChild ? '#3a455e' : '#ffffff',
        }}
        activeClassName={isChild ? classes.activeDrop : classes.active}
        activeStyle={{
          color: '#ffffff',
        }}
        className={dropDown && child ? classes.dropButton : classes.button}
        component={RouterLink}
        to={href}
        ref={activeItem}
        onClick={child ? handleOpenDropDown : handleCloseDropDown}
        // onClick={() => {
        //   if (child) {
        //     handleOpenDropDown()
        //     setIsChildren(false)
        //   } else {
        //     handleCloseDropDown()
        //     setIsChildren(false)
        //   }
        // }}
      >

        {Icon && child && (
          icon
        )}

        {Icon && !child && (
        <Icon
          size="20"
        />
        )}

        <div
          style={{
            // marginRight: '10px',
            margin: isChild ? '0 auto' : '0 10px 0 0',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
          // onClick={() => {
          //   setIsChildren(false)
          //   // alert('hi')
          // }}
        >
          <span
            style={{
              position: 'relative',
            }}
          >
            {title}
            {!!unSeen && unSeen !== 0 && title === 'اعلانیه‌ها' && <span className={classes.AlertIconStatus} />}
          </span>
        </div>

      </Button>
      {dropDown && child && child?.map((item) => (
        <div
          onClick={() => {
            setIsChildren(true)
          }}
          style={{ width: '230px' }}
        >
          <NavItem
            href={item.href}
            key={item.title}
            title={item.title}
          // icon={item.icon}
          // iconTwo={item.iconTwo}
            className={classes.button}
            isChild
            style={{ paddingTop: '0' }}
            isChildren={isChildren}

          />
        </div>
      ))}
    </ListItem>
  )
}

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  // iconTwo: PropTypes.elementType,
  title: PropTypes.string,
  onClick: PropTypes.func,
}

export default NavItem
